import { useCan } from 'src/utils/can';
import { ContentWrapper } from '../common/wrapper/content/wrapper';
import { Card } from '@otp/ui';
import { Report, ReportCard } from './report-card';
import {
  Actions,
  AppArea,
  DeploymentPartnerUserGroupsXlsDocument,
  OtpCoverageXlsDocument,
  StoresByOtpProXlsDocument,
  Subjects,
} from 'src/graphql/generated/graphql';

export const Reports = () => {
  const { can } = useCan();

  const reports: Report[] = [
    {
      id: 'reportStoresByOtpPro',
      name: 'Stores by OTP Pro',
      description: 'Stores by OTP Pro report xls',
      document: StoresByOtpProXlsDocument,
      key: 'reportStoresByOtpPro',
    },
    {
      id: 'reportOtpCoverage',
      name: 'OTP Coverage',
      description: 'OTP Coverage report xls',
      document: OtpCoverageXlsDocument,
      key: 'reportOtpCoverage',
    },
    {
      id: 'reportDeploymentPartnerUserGroups',
      name: 'Deployment Partner User Groups',
      description: 'Deployment Partner User Groups report xls',
      document: DeploymentPartnerUserGroupsXlsDocument,
      key: 'reportDeploymentPartnerUserGroups',
    },
  ];

  return (
    <ContentWrapper>
      <Card noBorder className="flex flex-col w-full bg-white">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
          {reports.map(
            (report: Report) =>
              can({
                action: Actions.Read,
                appArea: AppArea.Reporting,
                subject: Subjects.Reports,
                data: {
                  id: report.id,
                },
              }) && <ReportCard key={report.id} report={report} />,
          )}
        </div>
      </Card>
    </ContentWrapper>
  );
};
